module.exports = __webpack_public_path__ + "img/daily-long-walks.3ac4984c.png";